import { parseUnits } from 'ethers/lib/utils'

function tryParseAmount(value: string, decimals: number): boolean {
  if (!value) {
    return false
  }
  try {
    parseUnits(value, decimals)
  } catch (error) {
    // should fail if the user specifies too many decimal places of precision (or maybe exceed max uint?)
    console.debug(`Failed to parse input amount: "${value}"`, error)
    return false
  }
  return true
}

export default tryParseAmount
